import React from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";

import { classNames } from "utility/Utils";

interface AddWeekDropDownProps {
    // Callbacks
    onAddWeeks(weeks: number): void;
    onConfirmAddWeeks(): boolean;
}

const AddWeekDropDown = ({
    // Callbacks
    onAddWeeks,
    onConfirmAddWeeks
}: AddWeekDropDownProps) => {

    // ---=== Render ===--- //

    const renderMenuItems = () => {
        const menuItems = [];

        for (let week = 1; week <= 12; week++) {
            menuItems.push(
                <MenuItem key={`week-${week}`}>
                    {
                        ({ focus }) => (
                            <button
                                type="button"
                                onClick={() => onAddWeeks(week)}
                                className={
                                    classNames(
                                        `${focus ? "text-white bg-brand-500" : "text-brand-700"}`,
                                        "block w-full px-4 py-2 text-left text-sm cursor-pointer"
                                    )
                                }
                            >
                                {week} Week
                            </button>
                        )
                    }
                </MenuItem>
            );
        }

        return menuItems;
    };

    return (
        <React.Fragment>
            <Menu as="div" className="relative inline-block text-left">
                <div>
                    <MenuButton
                        className="inline-flex justify-center items-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white rounded-lg shadow border border-gray-300 hover:bg-gray-100 cursor-pointer"
                        onClick={(event) => {if (!onConfirmAddWeeks()) {event.preventDefault();}}}
                    >
                        <img className="flex justify-center items-center w-5 h-5 p-[1.67px]" src="/icons/plus.svg" alt="plus"/>
                        Add Weeks
                        <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true"/>
                    </MenuButton>
                </div>
                <MenuItems className="w-fit h-56 left-0 z-10 mt-1 absolute score overflow-y-auto overflow-x-hidden origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
                    <div className="py-1">
                        {renderMenuItems()}
                    </div>
                </MenuItems>
                {/*</Transition>*/}
            </Menu>
        </React.Fragment>
    );
};

export default AddWeekDropDown;
